import { get, postj } from '@/utils/request';

export const workList = (param) => get('work_order/list',param); // 工单列表
export const workDetail = (data) => get('work_order/detail',data); // 公告详情
export const workAdd = (data) => postj('work_order/create',data); // 新增
export const workReply = (data) => postj('work_order/reply',data); // 编辑